// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pinsir: PokeData = {
  "id": 127,
  "name": "pinsir",
  "height": 15,
  "weight": 550,
  "base_experience": 175,
  "types": [
    PokeType.BUG
  ],
  "api_moves": [
    "vice-grip",
    "guillotine",
    "swords-dance",
    "bind",
    "thrash",
    "submission",
    "seismic-toss",
    "strength",
    "harden",
    "focus-energy",
    "slash",
    "vital-throw",
    "superpower",
    "revenge",
    "brick-break",
    "x-scissor",
    "bug-bite",
    "double-hit",
    "storm-throw"
  ],
  "moves": [
    "seismic-toss",
    "superpower",
    "bug-bite",
    "pin-rush",
    "bug-buzz",
    "pin-missile",
    "leech-steal",
    "lunge",
    "string-shot",
    "infest",
    "sticky-web",
    "signal-spam",
    "heal-order"
  ],
  "evolution_chain": {
    "id": 62,
    "item": null,
    "species": [
      {
        "name": "pinsir",
        "order": 151,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 105,
    "speed": 119,
    "ability_power": 175
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
